import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Browse from "@/pages/Browse";
import DealDetail from "@/pages/DealDetail";
import MatchRoom from "@/pages/MatchRoom";
import MyDeals from "@/pages/MyDeals";
import Wallet from "@/pages/Wallet";
import Security from "@/pages/Security";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import AdminDashboard from "@/pages/AdminDashboard";
import TermsGate from "@/components/TermsGate";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="font-mono-code text-muted-foreground animate-pulse">Loading…</div>
  </div>
);

const Protected = ({ children, adminOnly }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/browse" replace />;
  return children;
};

const AppRoutes = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Auth mode="login" />} />
      <Route path="/signup" element={<Auth mode="signup" />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/browse" element={<Browse />} />
      <Route path="/deals/:dealId" element={<DealDetail />} />
      <Route path="/room/:matchId" element={<Protected><MatchRoom /></Protected>} />
      <Route path="/my-deals" element={<Protected><MyDeals /></Protected>} />
      <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
      <Route path="/security" element={<Protected><Security /></Protected>} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/admin" element={<Protected adminOnly><AdminDashboard /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <TermsGate />
          <Toaster position="top-right" richColors offset="80px" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
